import type { ComponentChildren } from 'preact';
import './InterpretationLabel.css';

export type InterpretationKind = 'verbatim' | 'interpreted' | 'assumed';

export interface InterpretationLabelProps {
  kind: InterpretationKind;
  children: ComponentChildren;
}

// Trust-posture primitive (2) — inference must never look like fact.
//   verbatim    — exact words from the source; blue, rendered in quotes.
//   interpreted — the assistant's reading of the source; violet, plain.
//   assumed     — a gap the assistant filled in, not stated anywhere;
//                 violet with a dotted underline, the weakest of the three.
export function InterpretationLabel({ kind, children }: InterpretationLabelProps) {
  if (kind === 'verbatim') {
    return (
      <span class="interp-label interp-label--verbatim">
        &ldquo;{children}&rdquo;
      </span>
    );
  }
  return <span class={`interp-label interp-label--${kind}`}>{children}</span>;
}
